// frontend/src/components/UI/Loader.jsx
import React from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import "./loader.scss";

const Loader = ({ size = "medium", fullScreen = false, message = "" }) => {
  const sizeMap = {
    small: "small",
    medium: "medium",
    large: "large",
  };

  const loaderClass = `loader-container ${fullScreen ? "full-screen" : ""}`;
  const spinnerClass = `loader-spinner ${sizeMap[size] || "medium"}`;

  return (
    <div className={loaderClass}>
      <motion.div
        className={spinnerClass}
        animate={{ rotate: 360 }}
        transition={{
          duration: 0.8,
          repeat: Infinity,
          ease: "linear",
        }}
      >
        <FontAwesomeIcon icon={faSpinner} spin />
      </motion.div>
      {message && <p className="loader-message">{message}</p>}
    </div>
  );
};

export default Loader;